import api from "../services/api";

export async function getFeature(id) {
  return await api.get("/Feature/GetEditModel", {
    params: {
      id: id,
    },
  });
}
